import * as base from './base';
import * as types from 'constants/action-types';
import * as api from 'api';

export const fetchReadings = (userId) => (dispatch, getState) => {
  const {readings} = getState();
  const hasNext = readings.getIn(['readingPages', 'hasNext']);
  const currentPage = readings.getIn(['readingPages', 'currentPage']);
  if (!hasNext) {
    return Promise.resolve();
  }
  const nextPage = currentPage + 1;
  return api.fetchReadings(nextPage, userId).then((response) => {
    dispatch(setReadings(response.records, nextPage, response.pageCount));
    return response;
  });
};

export const setReadings = (records, nextPage, pageCount) => ({
  type: types.SET_READINGS,
  records,
  nextPage,
  pageCount,
});

export const fetchReading = (recordId) => (dispatch) =>
  api.fetchReading(recordId).then((response) => {
    dispatch(setCurrentReading(response.record));
  });

export const setCurrentReading = (record) => ({
  type: types.SET_CURRENT_READING,
  record,
});

export const clearReadings = () => ({
  type: types.CLEAR_READINGS,
});

export const clearCurrentReading = () => ({
  type: types.CLEAR_CURRENT_READING,
});

export const fetchAdminReadings = (q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(api.fetchAdminReadings, setAdminReadings, q, page, perPage, sortOpts, extraFilters);

export const setAdminReadings = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_ADMIN_READINGS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const setCurrentAdminReadingPage = (page) => ({
  type: types.SET_CURRENT_ADMIN_READING_PAGE,
  page,
});

export const setCurrentAdminReading = (recordId, recordData) => ({
  type: types.SET_CURRENT_ADMIN_READING,
  recordId,
  recordData,
});

export const clearAdminReadingsAfterPage = (page) => ({
  type: types.CLEAR_ADMIN_READINGS_AFTER_PAGE,
  page,
});
